import Components from "../components";
import moment from 'moment-timezone';
import { localTZ } from "../lib/date_helpers";

class DatetimeInputs extends Components.Base {
  initialize() {
    this.$targetInput = this.$el.find(".datetime-final");
    this.$dateInput = this.$el.find("input[type=\"date\"]");
    this.$timeInput = this.$el.find("input[type=\"time\"]");
    this.$zone = this.$el.find(".zone");
  }

  updateTime(datetime) {
    let tz;
    if (this.context.user && this.context.user.timezone) {
      tz = this.context.user.timezone
    } else {
      tz = localTZ()
    }

    this.time = moment.tz(datetime, tz);
  }

  renderZone() {
    this.$el.find(".zone").text(this.time.zoneAbbr());
  }

  bind() {
    this.updateTime(this.$el.data('datetime'));
    this.renderZone();

    this.$timeInput.val(this.time.format("HH:mm"));
    this.$dateInput.val(this.time.format("YYYY-MM-DD"));

    this.$timeInput.on("change", this.dateChange.bind(this));
    this.$dateInput.on("change", this.dateChange.bind(this));
  }

  dateChange() {
    this.updateTime(`${this.$dateInput.val()} ${this.$timeInput.val()}`)
    this.renderZone();
    this.$targetInput.val(this.time.utc().toISOString());
  }
}

Components.collection.register({
  selector: '.c-datetime-inputs',
  klass: DatetimeInputs,
});
